import { createSlice } from "@reduxjs/toolkit";
const initialFacets = {
    currentFacets: [],
};
const facetsSlice = createSlice({
    name: "facets",
    initialState: initialFacets,
    reducers: {
        pushFacets(state, action) {
            state.currentFacets.push(action.payload);
        },
        updateFacets(state, action) {
            state.currentFacets.push(action.payload);
        },
        resetFacets() {
            return initialFacets;
        },
    },
});
export default facetsSlice;
